import {rootAPIUrl} from '__utils/constants'
//fetch Requests
export const requestsFetchURL = rootAPIUrl + "/requests/";
export const fetchRequestsSummaryUrl = rootAPIUrl + "/requests/summary/";